export default function MemoryMatchIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="6" y="10" width="24" height="32" rx="5" fill="#3B434F" transform="rotate(-8 18 26)" />
      <path d="M12 20l4 4M16 20l-4 4M20 30l4 4M24 30l-4 4" stroke="#20242C" strokeWidth="2.5" strokeLinecap="round" transform="rotate(-8 18 26)" />
      <rect x="22" y="16" width="24" height="32" rx="5" fill="#2F8BFF" />
      <path d="M34 24l3.2 6.4 7 .9-5.1 4.8 1.3 7-6.4-3.5-6.4 3.5 1.3-7-5.1-4.8 7-.9z" fill="#E7ECF3" transform="translate(-2.5 0)" />
      <rect x="38" y="22" width="22" height="30" rx="5" fill="#FF8A1F" transform="rotate(10 49 37)" />
      <circle cx="49" cy="37" r="6" fill="#E7ECF3" transform="rotate(10 49 37)" />
    </svg>
  );
}
